<template>
	<div>
		<b-row>
			<b-col md="12" class="mb-4">
				<h6>Null</h6>
				<multi-parameter-selectbox v-model="value1" code="days" sort="code"/>
				<span>{{ value1 }}</span>
			</b-col>
			<b-col md="12" class="mb-4">
				<h6>Multiple Selected</h6>
				<multi-parameter-selectbox v-model="value2" code="days" sort="code" :multiple="true"/>
				<span>{{ value2 }}</span>
			</b-col>
			<b-col md="12" class="mb-4">
				<h6>Validate Error</h6>
				<multi-parameter-selectbox v-model="value3" code="days"/>
				<span>{{ value3 }}</span>
			</b-col>
			<b-col md="12" class="mb-4">
				<h6>Validate Error</h6>
				<multi-parameter-selectbox v-model="value4" code="days" sort="code" :validateError="value4ValidateError"/>
				<span>{{ value4 }}</span>
			</b-col>
			<b-col cols="12">
				<b-button variant="primary" @click="change()">
					{{ $t('change').toUpper() }}
				</b-button>
			</b-col>
		</b-row>
	</div>
</template>
<script>
	import MultiParameterSelectbox from "@/components/interactive-fields/MultiParameterSelectbox";

	export default {
		components: {
			MultiParameterSelectbox,
		},
		data() {
			return {
				value1: null,
				value2: ['1', '7'],
				value3: ['1', '7'],
				value4: ['1', '7'],
				value4ValidateError: 'Validate Error is Working',
			}
		},
		methods: {
			change() {
				this.value2 = ["2", "3"]
				this.value3 = ["2", "3"]
				this.value4 = ["2", "3"]
				this.value4ValidateError = 'Error'
			}
		}
	};
</script>

